import urlPathName from './path-name';

type T = () => string | undefined;

const f: T = () => urlPathName().split('/')[1];

export default f;
